import React, { useEffect } from "react";
import { RxCross1 } from "react-icons/rx";
import { BsCartPlus } from "react-icons/bs";
import { AiOutlineHeart } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { removeFromWishlist } from "../../redux/actions/wishlist";
import { addTocart } from "../../redux/actions/cart";
import "./Wishlist.scss";

const Wishlist = ({ setOpenWishlist }) => {
  const { wishlist } = useSelector((state) => state.wishlist);
  const dispatch = useDispatch();

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleOverlayClick = () => {
    setOpenWishlist(false);
  };

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  const removeFromWishlistHandler = (item) => {
    dispatch(removeFromWishlist(item));
  };

  const addToCartHandler = (item) => {
    const newData = { ...item, qty: 1 };
    dispatch(addTocart(newData));
  };

  return (
    <div className="centered-wishlist-overlay" onClick={handleOverlayClick}>
      <div className="centered-wishlist-container" onClick={handleModalClick}>
        <button
          className="centered-wishlist-close-btn"
          onClick={() => setOpenWishlist(false)}
        >
          <RxCross1 size={20} />
        </button>

        <div className="centered-wishlist-header">
          <AiOutlineHeart size={20} />
          <h2>Мій Wishlist</h2>
        </div>

        {wishlist?.length === 0 ? (
          <div className="centered-wishlist-empty">
            <h3>Ваш список бажань пустий :(</h3>
            <p>Додайте товари, щоб перейти далі :)</p>
          </div>
        ) : (
          <div className="centered-wishlist-items">
            {wishlist.map((item, i) => (
              <WishlistItem
                key={i}
                data={item}
                removeFromWishlistHandler={removeFromWishlistHandler}
                addToCartHandler={addToCartHandler}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const WishlistItem = ({ data, removeFromWishlistHandler, addToCartHandler }) => {
  return (
    <div className="centered-wishlist-item">
      <button
        className="centered-wishlist-item-remove"
        onClick={() => removeFromWishlistHandler(data)}
      >
        <RxCross1 size={16} />
      </button>

      <img
        src={data.images?.[0]?.url || "/placeholder-image.jpg"}
        alt={data.name}
      />

      <div className="centered-wishlist-item-info">
        <h4>{data.name}</h4>
        {data.discountPrice ? (
          <p className="price">
            {data.originalPrice && data.originalPrice !== data.discountPrice && (
              <del style={{ marginRight: "8px" }}>
                {data.originalPrice.toLocaleString("uk-UA")} грн
              </del>
            )}
            <span>{data.discountPrice.toLocaleString("uk-UA")} грн</span>
          </p>
        ) : (
          <p className="price">
            {data.originalPrice
              ? `${data.originalPrice.toLocaleString("uk-UA")} грн`
              : "—"}
          </p>
        )}
      </div>

      <button
        className="centered-wishlist-item-add"
        onClick={() => addToCartHandler(data)}
        title="Add to cart"
      >
        <BsCartPlus size={20} />
      </button>
    </div>
  );
};

export default Wishlist;
